import bsCustomFileInput from 'bs-custom-file-input'
import JellyBelly from './JellyBelly';

document.addEventListener('DOMContentLoaded', () => JellyBelly.init(() => {
    bsCustomFileInput.init();
}));
